import { render, staticRenderFns } from "./InformationFieldEditor.vue?vue&type=template&id=1d3d3322&scoped=true"
import script from "./InformationFieldEditor.vue?vue&type=script&lang=js"
export * from "./InformationFieldEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3d3322",
  null
  
)

export default component.exports